import React, { useEffect, useMemo, useState } from 'react';
import './PopupPreview.css';
const sanitizeDomain = (domain) => {
    return domain.toLowerCase().replace(/[^a-z0-9-]/g, '-');
}

const PopupPreview = ({ formData, domain, selectedFolder }) => {
    const [cleanDomain, setCleanDomain] = useState('');
    useEffect(() => {
        if (domain) {
            const cleanDomain = domain.startsWith('http') ? domain : `https://${domain}`;
            setCleanDomain(cleanDomain);
        }
    }, [domain]);

    // Generate base URL with domain and sub-folder
    const baseUrl = useMemo(() => {
        if (!domain) return '';
        return selectedFolder && selectedFolder !== sanitizeDomain(domain) ? `${cleanDomain}/${selectedFolder}` : cleanDomain;
    }, [domain, selectedFolder]);

    // Get URLs with fallbacks
    const logoUrl = useMemo(() => {
        if (!formData?.logo?.url) return `${baseUrl}/logo.png`;
        console.log(formData?.logo?.url);
        return formData.logo.url.startsWith('http')
            ? formData.logo.url
            : formData.logo.url.startsWith('/') ? `${cleanDomain}${formData.banner.url}` : `${baseUrl}/${formData.logo.url}`;

    }, [formData?.logo?.url, baseUrl]);

    const bannerUrl = useMemo(() => {
        if (!formData?.banner?.url) return '';
        return formData.banner.url.startsWith('http')
            ? formData.banner.url
            : formData.banner.url.startsWith('/') ? `${cleanDomain}${formData.banner.url}` : `${baseUrl}/${formData.banner.url}`;
    }, [formData?.banner?.url, baseUrl]);

    const downloadUrl = useMemo(() => {
        if (!formData?.download?.url) return '';
        return formData.download.url.startsWith('http')
            ? formData.download.url
            : formData.download.url.startsWith('/') ? `${cleanDomain}${formData.banner.url}` : `${baseUrl}/${formData.download.url}`;
    }, [formData?.download?.url, baseUrl]);

    const interests = useMemo(() => {
        if (!formData?.interest) return [];
        return formData.interest.split(',').map(i => i.trim()).filter(Boolean);
    }, [formData?.interest]);

    const isDark = formData?.dark || false;
    const title = formData?.title || domain || 'Project Name';
    const phone = formData?.phone || '9778789788';
    const phone2 = formData?.phone2 || '';
    const whatsAppMessage = formData?.whatsAppMessage || "Hi! I'm interested in this project.";

    return (
        <div className="popup-preview-container">
            <div className="nav nav-tabs preview-tabs" role="tablist">
                <button
                    className="nav-link active"
                    data-bs-toggle="tab"
                    data-bs-target="#contact-preview"
                    type="button"
                >
                    Contact Form Preview
                </button>
                <button
                    className="nav-link"
                    data-bs-toggle="tab"
                    data-bs-target="#download-preview"
                    type="button"
                >
                    Download Form Preview
                </button>
            </div>

            <div className="tab-content preview-tab-content">
                {/* Contact Form Preview */}
                <div className="tab-pane fade show active" id="contact-preview">
                    <div className={`preview-modal ${isDark ? 'dark-theme' : ''}`}>
                        {/* Modal Header */}
                        <div className="preview-modal-header">
                            <div className="preview-logo">
                                {formData?.logo?.url ? (
                                    <img
                                        src={logoUrl}
                                        alt={formData?.logo?.alt || title}
                                        style={{
                                            height: formData?.logo?.height || '50px',
                                            width: formData?.logo?.width || 'auto'
                                        }}
                                        onError={(e) => {
                                            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="120" height="50"%3E%3Ctext x="5" y="30" font-family="Arial" font-size="14" fill="%23999"%3ELogo%3C/text%3E%3C/svg%3E';
                                        }}
                                    />
                                ) : (
                                    <span className="logo-placeholder">Logo</span>
                                )}
                            </div>
                            <button type="button" className="preview-close">×</button>
                        </div>

                        {/* Modal Body */}
                        <div className="preview-modal-body">
                            <div className="preview-row">
                                {/* Banner Image */}
                                <div className="preview-col-6">
                                    {bannerUrl ? (
                                        <img
                                            src={bannerUrl}
                                            alt={formData?.banner?.alt || title}
                                            className="preview-banner-img"
                                            onError={(e) => {
                                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="400"%3E%3Crect fill="%23f3f4f6" width="300" height="400"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="Arial" font-size="16" fill="%23999"%3EBanner Image%3C/text%3E%3C/svg%3E';
                                            }}
                                        />
                                    ) : (
                                        <div className="preview-banner-placeholder">
                                            <span>Banner Image</span>
                                        </div>
                                    )}
                                </div>

                                {/* Form */}
                                <div className="preview-col-6">
                                    <div className="preview-form-title">Contact Us</div>

                                    <div className="preview-form-group">
                                        <label>Name</label>
                                        <input type="text" className="preview-input" placeholder="Enter your name" disabled />
                                    </div>

                                    <div className="preview-form-group">
                                        <label>Phone</label>
                                        <input type="text" className="preview-input" placeholder="Enter your phone" disabled />
                                    </div>

                                    {interests.length > 0 && (
                                        <div className="preview-form-group">
                                            <label>Interest</label>
                                            <select className="preview-input" disabled>
                                                <option>Select Interest</option>
                                                {interests.map((interest, idx) => (
                                                    <option key={idx}>{interest}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    <button className="preview-btn">Submit</button>

                                    <hr className="preview-divider" />

                                    {/* Contact Info */}
                                    <div className="preview-contact-info">
                                        <div className="preview-contact-row">
                                            <i className="fa-solid fa-mobile"></i>
                                            <span>+91{phone}</span>
                                            {phone2 && (
                                                <>
                                                    <span className="mx-2">|</span>
                                                    <i className="fa-solid fa-mobile"></i>
                                                    <span>+91{phone2}</span>
                                                </>
                                            )}
                                        </div>
                                        <div className="preview-or">OR</div>
                                        <div className="preview-contact-row">
                                            <i className="fa-brands fa-whatsapp text-success"></i>
                                            <span>+91{phone}</span>
                                            {phone2 && (
                                                <>
                                                    <span className="mx-2">|</span>
                                                    <i className="fa-brands fa-whatsapp text-success"></i>
                                                    <span>+91{phone2}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Download Form Preview */}
                <div className="tab-pane fade" id="download-preview">
                    <div className={`preview-modal ${isDark ? 'dark-theme' : ''}`}>
                        {/* Modal Header */}
                        <div className="preview-modal-header">
                            <div className="preview-logo">
                                {formData?.logo?.url ? (
                                    <img
                                        src={logoUrl}
                                        alt={formData?.logo?.alt || title}
                                        style={{
                                            height: formData?.logo?.height || '50px',
                                            width: formData?.logo?.width || 'auto'
                                        }}
                                        onError={(e) => {
                                            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="120" height="50"%3E%3Ctext x="5" y="30" font-family="Arial" font-size="14" fill="%23999"%3ELogo%3C/text%3E%3C/svg%3E';
                                        }}
                                    />
                                ) : (
                                    <span className="logo-placeholder">Logo</span>
                                )}
                            </div>
                            <button type="button" className="preview-close">×</button>
                        </div>

                        {/* Modal Body */}
                        <div className="preview-modal-body">
                            <div className="preview-row">
                                {/* Download Image */}
                                <div className="preview-col-6">
                                    {downloadUrl ? (
                                        <img
                                            src={downloadUrl}
                                            alt={formData?.download?.alt || title}
                                            className="preview-download-img"
                                            onError={(e) => {
                                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="400"%3E%3Crect fill="%23f3f4f6" width="300" height="400"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="Arial" font-size="16" fill="%23999"%3EFloor Plan%3C/text%3E%3C/svg%3E';
                                            }}
                                        />
                                    ) : (
                                        <div className="preview-download-placeholder">
                                            <span>Floor Plan / Brochure</span>
                                        </div>
                                    )}
                                </div>

                                {/* Form */}
                                <div className="preview-col-6">
                                    <div className="preview-form-title">Download Now</div>

                                    <div className="preview-form-group">
                                        <label>Name</label>
                                        <input type="text" className="preview-input" placeholder="Enter your name" disabled />
                                    </div>

                                    <div className="preview-form-group">
                                        <label>Phone</label>
                                        <input type="text" className="preview-input" placeholder="Enter your phone" disabled />
                                    </div>

                                    {interests.length > 0 && (
                                        <div className="preview-form-group">
                                            <label>Interest</label>
                                            <select className="preview-input" disabled>
                                                <option>Select Interest</option>
                                                {interests.map((interest, idx) => (
                                                    <option key={idx}>{interest}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    <button className="preview-btn">Download</button>

                                    {/* Contact Info */}
                                    <div className="preview-contact-info-simple">
                                        <div className="preview-contact-row">
                                            <i className="fa-solid fa-mobile"></i>
                                            <span>+91{phone}</span>
                                            {phone2 && (
                                                <>
                                                    <span className="mx-2">|</span>
                                                    <i className="fa-solid fa-mobile"></i>
                                                    <span>+91{phone2}</span>
                                                </>
                                            )}
                                        </div>
                                        <div className="preview-or">OR</div>
                                        <div className="preview-contact-row">
                                            <i className="fa-brands fa-whatsapp text-success"></i>
                                            <span>+91{phone}</span>
                                            {phone2 && (
                                                <>
                                                    <span className="mx-2">|</span>
                                                    <i className="fa-brands fa-whatsapp text-success"></i>
                                                    <span>+91{phone2}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* URL Info */}
            {baseUrl && (
                <div className="preview-url-info">
                    <div className="url-info-item">
                        <strong>Base URL:</strong> <code>{baseUrl}</code>
                    </div>
                    {formData?.logo?.url && (
                        <div className="url-info-item">
                            <strong>Logo URL:</strong> <code>{logoUrl}</code>
                        </div>
                    )}
                    {formData?.banner?.url && (
                        <div className="url-info-item">
                            <strong>Banner URL:</strong> <code>{bannerUrl}</code>
                        </div>
                    )}
                    {formData?.download?.url && (
                        <div className="url-info-item">
                            <strong>Download URL:</strong> <code>{downloadUrl}</code>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PopupPreview;
